import * as React from 'react';
import CurrencyQuery from '../../Query/Currencies';
import { Input, Modal, Button, Select } from 'antd';

interface IDiscountInputPriceType {
  currencyId: string;
  priceWithout?: number | null;
  recommendedPriceWithout?: number | null;
  discount?: number | null;
  discountPercent?: number | null;
}

export interface IDiscountInputControlProps {
  name?: string;
  disabled?: boolean;
  prices: IDiscountInputPriceType[];
  currency?: GQL.ICurrency;
  currencies?: GQL.ICurrency[];
  onChange: Function;
}

interface IDiscountInputControlState {
  type: 'discount' | 'discountPercent';
  currency?: GQL.ICurrency;
}

export class DiscountInputControl extends React.Component<IDiscountInputControlProps, IDiscountInputControlState> {

  private inputRef;

  constructor(props: IDiscountInputControlProps) {
    super(props);

    const primaryCurrency = props.currencies
      && props.currencies.find((c: GQL.ICurrency) => c.primary === true);

    const stateCurrency = props.currency ? props.currency : primaryCurrency;

    const priceObject = stateCurrency && props.prices
      && props.prices.find((p: IDiscountInputPriceType) => p.currencyId === stateCurrency.id);

    let discountType: 'discount' | 'discountPercent' = 'discountPercent';
    if (priceObject && priceObject.discount !== null && priceObject.discount !== undefined) {
      discountType = 'discount';
    }

    this.state = {
      type: discountType,
      currency: stateCurrency,
    };

    this.inputRef = React.createRef();

    this.onChangeDiscountType = this.onChangeDiscountType.bind(this);
  }

  public render() {
    const { prices, disabled } = this.props;
    const { type, currency } = this.state;

    const priceObject = currency && prices
      && prices.find((p: IDiscountInputPriceType) => p.currencyId === currency.id);

    return (
      <React.Fragment>
        <Input
          disabled={disabled}
          name={this.props.name}
          ref={ref => this.inputRef = ref}
          type={'number'}
          step="0.01"
          addonAfter={
            <Select value={type} style={{ width: 'auto' }} onChange={this.onChangeDiscountType}>
              <Select.Option value="discountPercent">%</Select.Option>
              <Select.Option value="discount">{currency && currency.value}</Select.Option>
            </Select>}
          value={`${(priceObject && priceObject[type] !== null && priceObject[type] !== undefined
            ? priceObject[type] : ``)}`}
          onChange={(e: any) => this.onChange(e, currency)}
        />
      </React.Fragment>
    );
  }

  private onChangeDiscountType(discountType: string) {
    this.setState({
      type: (discountType.toLowerCase() === 'discountpercent' ? 'discountPercent' : 'discount'),
    }, () => {
      this.onChange({ target: { value: null } }, this.state.currency);
      if (this.inputRef) {
        this.inputRef.focus();
      }
    });
  }

  private onChange(e: any, currency?: GQL.ICurrency) {
    const { type } = this.state;

    const prices = [...this.props.prices];

    const newPrices = prices.map((p: IDiscountInputPriceType) => {
      if (currency && p.currencyId === currency.id) {
        // max. možná sleva
        const maxDiscount = type.toLowerCase() === 'discountpercent'
          ? 100
          : (p.recommendedPriceWithout || 0);

        // sleva + ošetření
        let discount = parseFloat(e.target.value) || 0;
        if (discount > maxDiscount) {
          discount = maxDiscount;
        }

        // hodnota slevy
        let discountValue = type.toLowerCase() === 'discountpercent'
          ? ((p.recommendedPriceWithout || 0) / 100) * discount
          : discount;

        p[type] = (discount > 0 ? discount : null);
        p[type.toLowerCase() === 'discountpercent' ? 'discount' : 'discountPercent'] = null;

        p.priceWithout = Math.round(((p.recommendedPriceWithout || 0) - discountValue) * 100) / 100;
      }

      return p;
    });

    // odeslání změny cen
    this.props.onChange({
      target: {
        name: this.props.name,
        value: newPrices,
      }
    });
  }
}

export default DiscountInputControl;


// WEBPACK FOOTER //
// ./src/components/Others/DiscountInput/DiscountInput.tsx